import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Reveal from "@/components/landing/Reveal";
import WaitlistForm from "@/components/landing/WaitlistForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ComingSoon() {
  const [count, setCount] = useState(null);

  const loadCount = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/waitlist/count`);
      setCount(res.data.count);
    } catch {
      /* counter is decorative */
    }
  }, []);

  useEffect(() => {
    loadCount();
  }, [loadCount]);

  return (
    <section id="coming-soon" data-testid="coming-soon-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-navy px-7 py-16 sm:px-14 sm:py-20 lg:px-20 text-center">
            <div
              className="absolute inset-0 opacity-40"
              style={{ background: "radial-gradient(ellipse 60% 50% at 50% 0%, rgba(200,90,50,0.35), transparent 70%)" }}
              aria-hidden="true"
            />
            <div className="relative">
              <p
                data-testid="coming-soon-eyebrow"
                className="inline-flex items-center gap-2.5 font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-amber-200/90 mb-7"
              >
                <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-bronze" />
                Coming Soon
              </p>
              <h2
                data-testid="coming-soon-heading"
                className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05] text-[#EAE5DC] max-w-3xl mx-auto"
              >
                Be first to join <span className="italic text-bronze">Vacansee</span>
              </h2>
              <p data-testid="coming-soon-subtext" className="mt-6 mb-12 text-base sm:text-lg font-light text-[#EAE5DC]/70 max-w-xl mx-auto leading-relaxed">
                Founding members get priority access to our launch cohort of 50 vetted companies — before the doors open to everyone.
              </p>
              <div className="flex flex-col items-center gap-5">
                <div className="w-full flex justify-center">
                  <WaitlistForm idPrefix="coming-soon" dark onSuccess={loadCount} />
                </div>
                <p data-testid="coming-soon-counter" className="font-mono text-xs tracking-[0.15em] uppercase text-[#EAE5DC]/50">
                  {count && count > 0
                    ? `Join ${count} early member${count === 1 ? "" : "s"}`
                    : "Be among the very first to join"}
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
